import i18n from '@/i18n';
import router from '@/router';
import ACTIONS from '@/store/storeActions';
import UserRestModel from '@/api/RestModels/user';
import RunRestModel from '@/api/RestModels/run';

export default class User {
  constructor(store) {
    this.$store = store;
  }

  async get(payload) {
    const self = this;
    try {
      const user = await UserRestModel.getToken(payload);
      await self.$store.dispatch(ACTIONS.SET_TOKEN, user.accessToken)
      const candidate = await UserRestModel.get();
      self.$store.dispatch(ACTIONS.SET_USER, candidate);
      const runDocuments = await RunRestModel.getDocumentNames();
      self.$store.dispatch(ACTIONS.SET_RUN_DOCUMENTS, runDocuments);
      router.push({ name: 'loader' })
    } catch (err) {
      let errMsg = null;
      switch (err.status) {
        case 401:
          errMsg = 'Errors.Validation.RecaptchaToken';
          break;
        case 404:
          errMsg = 'Errors.invalidToken';
          break;
        case 403:
          errMsg = 'Errors.personalizeFailed'
          break;
        default:
          errMsg = 'Errors.unknown'
      }
      self.$store.dispatch(ACTIONS.SET_SNACKBAR, { text: i18n.t(errMsg), color: 'error' });
    }
  }
}
